import { useAxios } from "@/hooks";
import { endPoint } from "@/utils";
import React from "react";
import { toast } from "react-hot-toast";


interface SubmitParams {
  values: Record<string, unknown>;
  resetForm: () => void;
}

export const useContactForm = () => {
  const { fetchData } = useAxios();
  const [submitted, setSubmitted] = React.useState(false);

  const handleSubmit = async ({ values, resetForm }: SubmitParams) => {
    const response = await fetchData({
      url: endPoint.POST_CONTACT_FORM,
      method: "POST",
      data: {
        ...values,
        /*
         * WHICH SITE and WHICH PAGE the enquiry came from.
         *
         * The backend stores both and puts them on the notification email as
         * its `Source` and `Page` rows. Without them every event-site enquiry
         * arrives looking identical to one from the main site, and support has
         * no way to tell where the person was or what they were reading when
         * they asked - which is most of the context in a message that is
         * often two lines long.
         *
         * The main site has sent these for a while; this form did not.
         */
        from: "FYDO_EVENT_WEBSITE",
        pageUrl: typeof window !== "undefined" ? window.location.pathname : "",
      },
    });

    if (response?.data) {
      setSubmitted(true);
      resetForm();
      toast.success("Form Submitted Successfully!");
      return;
    }

    toast.error(response?.message ?? "Something went wrong.");
  };

  return {
    submitted,
    handleSubmit,
  };
};
